import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import store from './store'
import VueHtmlToPaper from 'vue-html-to-paper'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import './permission'
import moment from 'moment'

Vue.config.productionTip = false

moment.locale('pt-br')
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

const options = {
  name: '_blank',
  specs: [
    'fullscreen=no',
    'titlebar=yes',
    'scrollbars=yes',
    'width=595p',
    'height=842'
  ],
  styles: [
    'https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.min.css',
    'https://cdn.jsdelivr.net/npm/vue/dist/vue.js'
  ]
}

Vue.use(VueHtmlToPaper, options)

Vue.use(Vuetify, {
  theme: {
    'toolbar': '#795548',
    'primary': '#26A69A',
    'light': '#D7CCC8',
    'dark': '#5D4037',
    'text': '#FFFFFF',
    'primary-text': '#212121',
    'secundary-text': '#757575',
    'divider': '#BDBDBD',
    'secondary': '#424242',
    'accent': '#26A69A',
    'error': '#E57373',
    'info': '#4FC3F7',
    'success': '#66BB6A',
    'warning': '#FFA726'
  }
})

export const bus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js